import { makeStyles, Theme, createStyles } from "@material-ui/core";
import { Fragment } from "react";
import { observer } from "mobx-react";
import { AccountPlus } from "mdi-material-ui";
import TableToolbar from "../../../../Shared/Table/TableToolbar";
import REMButton from "../../../../../shared/modules/rem-conversion/components/Button";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        noWrap: {
            textWrap: 'nowrap'
        }
    }),
);

interface AdministratorsOverviewMainMenuProps {
    onNewRecordClicked: () => void;
}

const AdministratorsOverviewMainMenu = observer((props: AdministratorsOverviewMainMenuProps) => {

    const classes = useStyles();

    /********* Render *********/

    return (
        <TableToolbar
            leftButtons={
                <Fragment>
                    <REMButton
                        startIcon={<AccountPlus />}
                        color="primary"
                        variant="contained"
                        size="large"
                        onClick={props.onNewRecordClicked}
                        className={classes.noWrap}
                    >
                        New Admin
                    </REMButton>
                </Fragment>
            }
        />
    );
});

export default AdministratorsOverviewMainMenu;